"use client";

import { BlogLink, Content, Header } from "@/components/shared/public/blogs";
import { useTranslations } from "next-intl";
import {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
} from "../../../../../../public/images/blogs/floorPlanDrawingOnline";

export default function BlogContent() {
  const t = useTranslations("blogs.floorPlanDrawingOnline");

  return (
    <>
      <Header
        title={t("header.title")}
        text={t("header.text")}
        src={header}
        alt={t("header.imageAlt")}
      />
      <div className="gs--blog-body flex flex-col gap-10 py-16">
        <Content
          imageFit="cover"
          title={t("sections.section1.title")}
          text={t.rich("sections.section1.text", {
            br: () => <br></br>,
            link1: (chunks) => (
              <BlogLink href="/blog/expose">{chunks}</BlogLink>
            ),
          })}
          src={section1}
          alt={t("sections.section1.imageAlt")}
          imageLeft={true}
        />
        {/* colImagePortraitFormat: resizing image in correct scale without cutting off the lower part at the bottom of the image. */}
        <Content
          colImagePortraitFormat
          noShadow
          title={t("sections.section2.title")}
          text={t.rich("sections.section2.text", {
            br: () => <br></br>,
            ul: () => (
              <ul>
                {[0, 1, 2, 3].map((i) => (
                  <li key={i}>
                    {t.rich(`sections.section2.list.${i}`, {
                      bold: (chunks) => <strong>{chunks}</strong>,
                      link1: (chunks) => (
                        <BlogLink href="/blog/cad-system">{chunks}</BlogLink>
                      ),
                    })}
                  </li>
                ))}
              </ul>
            ),
          })}
          src={section2}
          alt={t("sections.section2.imageAlt")}
        />
        <Content
          imageFit="cover"
          title={t("sections.section3.title")}
          text={t.rich("sections.section3.text", {
            br: () => <br></br>,
            ul: () => (
              <ul>
                {[0, 1, 2, 3, 4, 5].map((i) => (
                  <li key={i}>
                    {t.rich(`sections.section3.list.${i}`, {
                      bold: (chunks) => <strong>{chunks}</strong>,
                    })}
                  </li>
                ))}
              </ul>
            ),
          })}
          src={section3}
          alt={t("sections.section3.imageAlt")}
          imageLeft={true}
        />
        <Content
          title={t("sections.section4.title")}
          text={t.rich("sections.section4.text", {
            br: () => <br></br>,
            link1: (chunks) => (
              <BlogLink href="/blog/aufmass-nehmen">{chunks}</BlogLink>
            ),
            ul: () => (
              <ul>
                {[0, 1, 2, 3].map((i) => (
                  <li key={i}>
                    {t.rich(`sections.section4.list.${i}`, {
                      bold: (chunks) => <strong>{chunks}</strong>,
                    })}
                  </li>
                ))}
              </ul>
            ),
          })}
          src={section4}
          alt={t("sections.section4.imageAlt")}
        />
        <Content
          title={t("sections.section5.title")}
          text={t.rich("sections.section5.text", {
            br: () => <br></br>,
            ol: () => (
              <ol>
                {[0, 1, 2, 3, 4].map((i) => (
                  <li key={i}>
                    {t.rich(`sections.section5.list.${i}`, {
                      bold: (chunks) => <strong>{chunks}</strong>,
                      link1: (chunks) => (
                        <BlogLink href="/blog/bauzeichnung">{chunks}</BlogLink>
                      ),
                    })}
                  </li>
                ))}
              </ol>
            ),
          })}
          src={section5}
          alt={t("sections.section5.imageAlt")}
          imageLeft={true}
        />
        <Content
          title={t("sections.section6.title")}
          text={t.rich("sections.section6.text", {
            br: () => <br></br>,
            link1: (chunks) => (
              <BlogLink href="/blog/grundriss-digitalisieren">
                {chunks}
              </BlogLink>
            ),
          })}
          src={section6}
          alt={t("sections.section6.imageAlt")}
          disclaimer="default"
        />
      </div>
    </>
  );
}
